import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { ToggleableMeasurement } from './model';
import { ConvertedMeasurementView } from '../convertedmeasurement/view';
import { FeetAndInches } from '../feetandinches/view';

interface ToggleableMeasurementParams {
    model : ToggleableMeasurement,
    textonly? : boolean,
    disabled?: boolean,
    placeholder?: string,
    tabindex? : { _? : number, inches? : number }
}

export const ToggleableMeasurementView = SuperCritical(({ model, textonly = false, disabled = false, placeholder, tabindex } : ToggleableMeasurementParams) =>
    <span className="toggleablemeasurement">
        {model.conversions.map(conversion => 
            <span hidden={conversion.uom !== model.uom()} key={conversion.uom}>
                {textonly ?
                    [<span className="toggleablemeasurement-value" key="feetandinches">{conversion.feetAndInches ? conversion.feetAndInches.toString() : ''}</span>,
                     <span className="toggleablemeasurement-value" key="converted">{conversion.converted ? conversion.converted.toString() : ''}</span>]
                : 
                    [conversion.feetAndInches ?
                        <FeetAndInches key="feetandinches" model={conversion.feetAndInches} disabled={disabled} placeholder={placeholder} tabindex={{ feet: tabindex && tabindex._, inches: tabindex && tabindex.inches }} />
                        : null,
                    conversion.converted ?
                        <ConvertedMeasurementView key="converted" model={conversion.converted} disabled={disabled} placeholder={placeholder} tabindex={tabindex && tabindex._} />
                        : null]
                }
            </span>
        )}
    </span>);


// WEBPACK FOOTER //
// ./apps/portcall/toggleablemeasurement/view.tsx